<template>
</template>

<script>

export default {
  name: 'GlobalSearch',
  components: {
  },
  computed : {
  },
  data()
  {
    return {

    }
  },
  methods : {
  }
}
</script>

<style scoped lang="scss">
</style>
